/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DeadlineDto {
  id?: string;
  undoDeadline?: string;
  status?: DeadlineDto.StatusEnum;
  rejectionCode?: string;
}
export namespace DeadlineDto {
  export const StatusEnum = {
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Scheduled: 'SCHEDULED',
    Fulfilled: 'FULFILLED',
    Revoked: 'REVOKED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
